import { useSupportLauncherPlacement } from "@/hooks/useSupportLauncherPlacement";

/**
 * Drives the placement of the native Intercom launcher — the permanent support
 * entry point. Renders nothing; mounted once in the authenticated shell so the
 * bubble follows the page it floats over, on every route and both formats.
 */
export const SupportLauncher = (): null => {
  useSupportLauncherPlacement();
  return null;
};
